import { createAction } from '@reduxjs/toolkit';

import type { GenerateRecommendedVideoResponse } from 'js/src/client';
import type { DatasetMetadata } from 'js/src/data/recommendations/recommendations-types';
import { ACTIONS } from 'js/src/data/recommendations/recommendations-types';

export const setSourceSegmentForRephrasedScene = createAction<{
    sceneId: string;
    sourceSegment: string;
}>(ACTIONS.SET_SOURCE_SEGMENT_FOR_SCENE);

export const setDatasetMetadata = createAction<{
    metadata: DatasetMetadata;
}>(ACTIONS.SET_DATASET_METADATA);

export const setRecommendedVideoResponse = createAction<{
    response: GenerateRecommendedVideoResponse;
}>(ACTIONS.SET_RECOMMENDED_VIDEO_REQUEST_RESPONSE);

export const clearRecommendations = createAction(ACTIONS.CLEAR_RECOMMENDATIONS);
